module.exports = __webpack_public_path__ + "static/img/super_sign_banner.0595358.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/super_sign_banner.png
// module id = kIIb
// module chunks = 1